export function ConfirmDialog({
  open,
  title,
  message,
  confirmText = "確認執行",
  cancelText = "取消",
  variant = "normal",
  loading = false,
  onConfirm,
  onCancel
}: {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "normal" | "danger";
  loading?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}) {
  if (!open) return null;

  return (
    <div className="game-modal-backdrop">
      <section className={`game-modal confirm-dialog ${variant === "danger" ? "error" : "info"}`}>
        <div className="modal-orb" />
        <h2>{title}</h2>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-actions">
          <button className="secondary-cta" type="button" disabled={loading} onClick={onCancel}>
            {cancelText}
          </button>
          <button className="primary-cta" type="button" disabled={loading} onClick={onConfirm}>
            {loading ? "處理中..." : confirmText}
          </button>
        </div>
      </section>
    </div>
  );
}
